export default {
    install(Vue, options) {
        //  时间  2010-01-12
        Vue.filter('getTime', function (val) {
            let day = new Date(val * 1000);
            let y = day.getFullYear();
            let m = day.getMonth() + 1;
            let d = day.getDate();
            return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
        });
        //  时间  2010-01-12 10:00
        Vue.filter('getNewTime', function (val) {
            let day = new Date(val * 1000);
            let y = day.getFullYear();
            let m = day.getMonth() + 1;
            let d = day.getDate();
            let h = day.getHours();
            let s = day.getMinutes();
            return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + '  ' + (h < 10 ? '0' + h : h) + ':' + (s < 10 ? '0' + s : s);
        });
        // 时间  12:00
        Vue.filter('getDateTime', function (val) {
            let day = new Date(val * 1000);
            let h = day.getHours();
            let m = day.getMinutes();
            return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
        });
        Vue.filter('getTimeDifference', function (val) {
            var date1 = (Date.parse(new Date()))/1000;//计算当前时间戳 
            var date3 =  val- date1; //时间差的毫秒数
            if(date3 / (24 * 3600 ) >0 && date3 / (24 * 3600 ) < 1){return Math.floor(date3 / (24 * 3600 )*24)+"小時"}
            return Math.ceil(Math.abs(date3 / (24 * 3600 )))+"天";
        });

        // 千分货币格式 11,000
        Vue.filter('numFormat', function (val) {
            if (!val) {return '0';}
            return val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        });
        Vue.filter('priceUnit', function (val) {
            if (!val) {return '$0';}
    
            // 强制转换为数字（或者使用 BigInt 处理更极大的数）
            let num = parseFloat(val); 
            let k = 10000;
            let sizes = ['', '萬', '億'];
            let unitIndex = 0;
        
            // 循环判断，只要数字大于万，就除以万，并提升单位等级
            // 同时确保 unitIndex 不会超过数组最大索引
            while (num >= k && unitIndex < sizes.length - 1) {
                num = num / k;
                unitIndex++;
            }
        
            // 保留两位小数并去掉末尾多余的0
            let formattedVal = parseFloat(num.toFixed(2));
            
            return '$' + formattedVal + sizes[unitIndex];
        });
    }
};
